import { render, staticRenderFns } from "./OpprNav.vue?vue&type=template&id=51c418c2&lang=pug&"
import script from "./OpprNav.vue?vue&type=script&lang=js&"
export * from "./OpprNav.vue?vue&type=script&lang=js&"
import style0 from "./OpprNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports